var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 28,
    viewBox: "0 0 13 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4686 19.4587H9.62736L11.5794 5.4177L6.5 0L1.41038 5.4177L3.36242 19.4587H0.531447C0.235063 19.4587 0 19.6942 0 19.9912L0 22.4184C0 22.7154 0.235063 22.951 0.531447 22.951H4.75236L4.75236 27.3138C4.75236 27.6928 5.05896 28 5.43711 28H7.54245C7.9206 28 8.2272 27.6928 8.2272 27.3138V22.951H12.4686C12.7649 22.951 13 22.7154 13 22.4184V19.9912C12.9898 19.6942 12.7547 19.4587 12.4686 19.4587Z",
    fill: "#4FFF8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSword);
export default __webpack_public_path__ + "static/media/sword.c4c11c22459937bce849b0dc31997fcd.svg";
export { ForwardRef as ReactComponent };